/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "d802e3dbd35ceaccabd4f2f5c4cd3941fb4bd7e7";
